export const COUNTRY_LANGUAGE_STORAGE_KEY = 'ai_tracking_country_language';

/**
 * Country/language the current user last submitted anywhere in AI tracking, or null.
 *
 * The entry is keyed by user so a shared browser does not leak one account's pick into another's.
 */
export function getStoredCountryLanguage() {
    try {
        const stored = JSON.parse(localStorage.getItem(COUNTRY_LANGUAGE_STORAGE_KEY));
        return stored?.[window.info?.user] ?? null;
    } catch (e) {
        console.log('e', e);
        return null;
    }
}

/** Remember the country/language the current user just submitted, scoped to their account. */
export function saveCountryLanguage({ country, language }) {
    try {
        const existing = JSON.parse(localStorage.getItem(COUNTRY_LANGUAGE_STORAGE_KEY)) ?? {};
        existing[window.info?.user] = { country, language };
        localStorage.setItem(COUNTRY_LANGUAGE_STORAGE_KEY, JSON.stringify(existing));
    } catch (e) {
        console.log('e', e);
    }
}

/**
 * Country/language to preselect once a project is known.
 *
 * A project's own defaults win: they are exactly what the backend's `resolve_country_language`
 * falls back to when the request omits the fields, so preselecting them keeps what the form shows
 * and what the server would use in sync. When the project defines neither, we fall back to the
 * user's last pick from localStorage, then to `fallback` (a caller-specific hint, e.g. the
 * country/language the project's existing prompts are already tracked with).
 *
 * Each field resolves independently because the project model allows one to be set without the
 * other. Blank values are treated as unset, so an empty string never wins over a usable fallback.
 */
export function resolveCountryLanguage(project, fallback = {}) {
    const stored = getStoredCountryLanguage();

    return {
        country: project?.country || stored?.country || fallback.country || '',
        language: project?.language || stored?.language || fallback.language || '',
    };
}
